import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as actionTypes from './constants';

export const isLoadingStandaloneMode = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_STANDALONE_MODE_SUCCESS,
      actionTypes.FETCH_STANDALONE_MODE_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_STANDALONE_MODE_REQUEST,
    )]: () => true,
  },
  false,
);

export const standaloneMode = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_STANDALONE_MODE_REQUEST,
      actionTypes.FETCH_STANDALONE_MODE_FAILURE,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_STANDALONE_MODE_SUCCESS,
      actionTypes.UPDATE_STANDALONE_MODE_SUCCESS,
    )]: (state, { payload }) => payload,
  },
  {},
);

export const isUpdatingStandaloneMode = handleActions(
  {
    [combineActions(
      actionTypes.UPDATE_STANDALONE_MODE_SUCCESS,
      actionTypes.UPDATE_STANDALONE_MODE_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_STANDALONE_MODE_REQUEST,
    )]: () => true,
  },
  false,
);

export const updateStandaloneModeSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPDATE_STANDALONE_MODE_REQUEST,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_STANDALONE_MODE_SUCCESS,
    )]: () => true,
  },
  false,
);

export const standaloneModeError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_STANDALONE_MODE_REQUEST,
      actionTypes.FETCH_STANDALONE_MODE_SUCCESS,
      actionTypes.UPDATE_STANDALONE_MODE_REQUEST,
      actionTypes.UPDATE_STANDALONE_MODE_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_STANDALONE_MODE_FAILURE,
      actionTypes.UPDATE_STANDALONE_MODE_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  isLoadingStandaloneMode,
  standaloneMode,
  isUpdatingStandaloneMode,
  updateStandaloneModeSuccess,
  standaloneModeError,
});
